import { render, staticRenderFns } from "./ObeSettings.vue?vue&type=template&id=c9dd9abe"
import script from "./ObeSettings.vue?vue&type=script&lang=js"
export * from "./ObeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports